import './index.css'

import React, { Component } from 'react'

class LevelBarComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value,
      enabled: this.props.enabled,
      label: this.props.label,
      field: this.props.field,
    }
  }

  onClick = e => {
    if (!this.state.enabled) return

    const value = e.target.getAttribute('value')
    this.setState({ value })

    this.props.update(this.state.field, value)
  }

  render() {
    let value = 'disabled'
    if (this.state.enabled) {
      value = this.state.value
    }

    let itemClassName = `level-bar-item item-style ${value}`
    let itemSelectedClassName = `item-selected ${this.state.value} ${value}`
    let barClassName = `level-bar-content ${value}`
    let labelClassName = `label ${value}`

    return (
      <div className="text-input">
        <label className="text-input-label">
          <div>
            Level — &nbsp;
            <span className={labelClassName}>{this.state.value}</span>
          </div>
        </label>

        <div className={barClassName}>
          <div className={itemClassName} onClick={this.onClick} value="novice"></div>
          <div className={itemClassName} onClick={this.onClick} value="beginner"></div>
          <div className={itemClassName} onClick={this.onClick} value="skillful"></div>
          <div className={itemClassName} onClick={this.onClick} value="experienced"></div>
          <div className={itemClassName} onClick={this.onClick} value="expert"></div>
          <div className={itemSelectedClassName}></div>
        </div>
      </div>
    )
  }
}

LevelBarComponent.defaultProps = { field: 'field', label: 'label', enabled: true, value: 'novice' }
export default LevelBarComponent
